import "../../css/widgets/widgets.css";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';

function OutgoingCalls(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [missed, setMissed] = useState(0);
    const [groupAll, setGroupAll] = useState(0);
    const [groupAttended, setGroupAttended] = useState(0);
    const [groupMissed, setGroupMissed] = useState(0);

    useEffect(() => {
        let outgoingcalls = props.calls.filter(x => x.interlocutor !== null && !x.incoming);
        setAll(outgoingcalls.length)
        setAttended(outgoingcalls.filter(x => x.connected).length);
        setMissed(outgoingcalls.filter(x => !x.connected).length);
        setGroupAll(outgoingcalls.filter(x => x.groupId > -1).length)
        setGroupAttended(outgoingcalls.filter(x => x.connected && x.groupId > -1).length);
        setGroupMissed(outgoingcalls.filter(x => !x.connected && x.groupId > -1).length);
        setGroupMissed(outgoingcalls.filter(x => !x.connected && x.groupId > -1).length);
        return () => {
            // component unmounts
        };
    }, [props.calls]);


    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-up-right")} /> {t("outgoingcalls")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("all")}</span></Col>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("campaigncalls")}</span></Col>
                </Row>
                <Row>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-gray-800">{all}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-success">{attended}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-danger">{missed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-gray-800">{groupAll}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-success">{groupAttended}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}>
                        <div className="fs-2hx fw-bold text-danger">{groupMissed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                </Row>
            </div>
        </div>

    )
}
export default OutgoingCalls;